
(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.trending = {
    attach: function () {
      var nodes = $('article.node--view-mode-full:not(.trending-processed)');
      if (nodes.length) {
        nodes.addClass('trending-processed').each(function () {
          var nid = $(this).data('entityId');
          if (nid && !$('body').hasClass('user-logged-in')) {
            $.getJSON('/trending_api/addVisit/' + nid);
          }
        });
      }
    }
  };

})(jQuery, Drupal, drupalSettings);
